import React, { createContext, useContext } from 'react';

const TabsContext = createContext(null);

const Tabs = ({ value, onValueChange, children, className = '' }) => {
    return (
        <TabsContext.Provider value={{ value, onValueChange }}>
            <div className={`w-full ${className}`}>
                {children}
            </div>
        </TabsContext.Provider>
    );
};

const TabsList = ({ children, className = '' }) => {
    return (
        <div className={`inline-flex items-center justify-center rounded-lg bg-gray-100 p-1 text-muted-foreground ${className}`}>
            {children}
        </div>
    );
};

const TabsTrigger = ({ value, children, className = '' }) => {
    const context = useContext(TabsContext);
    const isActive = context.value === value;

    return (
        <button
            type="button"
            onClick={() => context.onValueChange(value)}
            className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
                isActive 
                ? 'bg-purple-50 text-sm-primary border-sm-primary border-[1px] shadow-sm' 
                : 'hover:bg-white/50 hover:text-foreground'
            } ${className}`}
        >
            {children}
        </button>
    );
};

const TabsContent = ({ value, children, className = '' }) => {
    const context = useContext(TabsContext);
    if (context.value !== value) return null;

    return (
        <div className={`mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${className}`}>
            {children}
        </div>
    );
};

export { Tabs, TabsList, TabsTrigger, TabsContent };
